<script setup>
import { useModalStore } from "@/stores/ModalStore"
import { useEventStore } from "@/stores/EventsStore"
import CustomerNameSurnamePhone from "@/components/customer/CustomerNameSurnamePhone.vue"
import { useI18n } from 'vue-i18n'
import { useCalendarStore } from "@/views/apps/calendar/useCalendarStore"

const THIS_MODAL_NAME = 'cancelEvent'
const modalStore = useModalStore()
const eventStore = useEventStore()
const { t } = useI18n()
const calendarStore = useCalendarStore()

const isLoading = ref(false)

const selectedCustomer = modalStore.modalParams.cancelEvent.selectedCustomer
const otherCyclicalVisits = modalStore.modalParams.cancelEvent.otherCyclicalVisits
const refetchEventsOnCalendar = modalStore.modalParams.cancelEvent.refetchEventsOnCalendar
const closeAllModals = modalStore.modalParams.cancelEvent.closeAllModals


const modelObject = ref({
  eventId: modalStore.modalParams.cancelEvent.eventId,
  includeCyclicEvents: false,
  reason: 0,
  comment: '',
})

const cancelVisitSubmit = async () => {
  isLoading.value = true
  try {
    const response = await $backend('/events/cancel', {
      method: 'POST',
      body: modelObject.value,
    })
    if(response.success) {
      showSuccessToast(response.message)
      if(refetchEventsOnCalendar) {
        eventStore.selectedEvent.id = null
        calendarStore.calendarApi?.refetchEvents()
      }
      if(closeAllModals) {
        modalStore.resetModals()
      } else {
        modalStore.closeModal(THIS_MODAL_NAME, { success: true, data: response.data })
      }
    } 
  } catch (e) {
    //
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <VDialog
    :model-value="modalStore.modals.cancelEvent"
    width="600px"
    persistent
  >
    <VCard
      class="pa-2"
      :disabled="isLoading"
      :loading="isLoading"
    >
      <VCardTitle>
        <div class="d-flex justify-space-between center">
          <p class="ma-0 white-space-normal line-height-normal">
            {{ $t('revoking_visit') }} <br>
            <CustomerNameSurnamePhone class="mt-2" :customer-object="selectedCustomer" />

          </p>

          <VIcon
            icon="ri-close-line"
            :disabled="eventStore.isLoading"
            @click="modalStore.closeModal(THIS_MODAL_NAME)"
          />
        </div>

      </VCardTitle>
      <VCardText v-if="otherCyclicalVisits.length > 0">
        <p>
          {{ $t('cyclic_visit_cancelation.there_are_cyclic_events_assigned') }}
        </p>
         
        <VAlert
          variant="tonal"
          type="warning"
        >
          <p class="mb-1">
            {{ $t('cyclic_visit_cancelation.dates_of_visits') }}:
          </p>
          <VListItem
            v-for="(cyclicEvent, index) in otherCyclicalVisits"
            density="compact"
            :key="index"
            class="pa-0"
            color="primary"
          >
            {{ cyclicEvent.date }}
          </VListItem>
        </VAlert>

        <VForm ref="visitCancelForm">
          <VRow v-if="otherCyclicalVisits.length > 0">
            <VCol class="">
<!--              <VCheckbox-->
<!--                v-model="modelObject.includeCyclicEvents"-->
<!--                :label="$t('cyclic_visit_cancelation.cancel_events_above')"-->
<!--              />-->
              <div class="d-flex flex-column align-center ">
                <p class="mt-4 mb-0 text-center">
                  {{ $t('cyclic_visit_cancelation.cancel_events_above') }}
                </p>
                <VRadioGroup
                  v-model="modelObject.includeCyclicEvents"
                  inline
                >
                  <VRadio
                    class="mx-2"
                    :label="t('yes')"
                    :value="true"
                  />
                  <VRadio
                    class="mx-2"
                    :label="t('no')"
                    :value="false"
                  />
                </VRadioGroup>
              </div>

            </VCol>
          </VRow>
          <VRow>
            <VCol
              cols="12"
              class="px-0"
            >
              <VSelect
                v-model="modelObject.reason"
                :label="$t('select_reason')"
                :items="calendarStore.reasonsForEventCancellation"
                item-title="text"
                item-value="id"
              />
            </VCol>
            <VCol
              cols="12"
              class="px-0"
            >
              <VTextarea
                v-model="modelObject.comment"
                maxlength="255"
                :label="$t('comments')"
              />
            </VCol>
          </VRow>
        </VForm>
      </VCardText>
      <VCardText v-else>
        <VRow>
          <VCol
            cols="12"
            class="px-0"
          >
            <VSelect
              v-model="modelObject.reason"
              :label="$t('select_reason')"
              :items="calendarStore.reasonsForEventCancellation"
              item-title="text"
              item-value="id"
            />
          </VCol>
          <VCol
            cols="12"
            class="px-0"
          >
            <VTextarea
              v-model="modelObject.comment"
              maxlength="500"
              :label="$t('comments')"
            />
          </VCol>
        </VRow>
      </VCardText>
      <VCardActions>
        <div class="d-flex justify-space-between flex-fill">
          <VBtn
            color="secondary"
            variant="outlined"
            @click="modalStore.closeModal(THIS_MODAL_NAME)"
          >
            {{ $t('cancel') }}
          </VBtn>
          <VBtn
            type="submit"
            color="primary"
            variant="elevated"
            @click="cancelVisitSubmit"
          >
            {{ $t('revoke_visit') }}
          </VBtn>
        </div>
      </VCardActions>
    </VCard>
  </VDialog>
</template>


